const transformVideoData = require("./transformVideoData");
const extractLinkData = require("./extractLinkData");
const extractFileData = require("./extractFileData");
const findFeaturedImage = require("./findFeaturedImage");
const slugify = require("./slugify");

module.exports = function transformHighlightData(entity, sitemap) {
	const { attributes, id, type, relationships } = entity;
	const link =
		attributes && attributes.field_to
			? extractLinkData(attributes.field_to, sitemap)
			: null;
	const buttons =
		attributes && Array.isArray(attributes.field_buttons)
			? attributes.field_buttons.map((a_btn) => extractLinkData(a_btn, sitemap))
			: null;
	let video;
	let image;
	let _image_rel = findFeaturedImage(relationships);
	if (_image_rel) {
		video =
			_image_rel.type === "media--video"
				? transformVideoData(undefined, undefined, _image_rel)
				: null;
		image =
			_image_rel.type === "media--image"
				? extractFileData(_image_rel, "field_media_image")
				: null;
	}
	let orientation =
		attributes && attributes.field_image_orientation
			? attributes.field_image_orientation
			: null;
	let layout =
		attributes && attributes.field_highlight_layout
			? attributes.field_highlight_layout
			: null;
	let style =
		attributes && attributes.field_highlight_style
			? attributes.field_highlight_style
			: "default";
	let txt = attributes.body
		? attributes.body.transformed
			? attributes.body.transformed
			: attributes.body.value
		: null;
	let data = {
		id,
		type,
		title: attributes.title,
		anchor: slugify(attributes.title),
		video,
		image,
		text: txt,
		link,
		buttons,
		orientation,
		layout,
		style,
		flush: attributes.field_entities_list_flush ? true : false,
		underline: attributes.field_color_hex ? attributes.field_color_hex : null,
		buttonColor: attributes.field_color ? attributes.field_color : "secondary",
		buttonStyle: attributes.field_button_style
			? attributes.field_button_style
			: "default",
	};
	return data;
};
